'use client';

import { FC, useEffect, useRef } from 'react';
import { PageViewData } from '../types';
import { trackPageView } from '../core';
import { usePathname } from 'next/navigation';

type Props = {
  data?: Partial<PageViewData>;
};

export const TrackPageView: FC<Props> = ({ data }) => {
  let pathname = usePathname();
  let trackedPathname = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (trackedPathname.current === pathname) {
      return;
    }

    trackedPathname.current = pathname ?? undefined;
    trackPageView(data);
  }, [pathname]);

  return null;
};
